// extracted by mini-css-extract-plugin
module.exports = {"visitsToConfirmContainer":"visitsToConfirm_visitsToConfirmContainer__gC9V6","separator":"visitsToConfirm_separator__0QSwD"};